/* tslint:disable */
/* eslint-disable */
/**
 * Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    AcademicUserNameDTO,
    AcademicUserNameDTOFromJSON,
    AcademicUserNameDTOFromJSONTyped,
    AcademicUserNameDTOToJSON,
} from './AcademicUserNameDTO';
import {
    SemesterTypeEnum,
    SemesterTypeEnumFromJSON,
    SemesterTypeEnumFromJSONTyped,
    SemesterTypeEnumToJSON,
} from './SemesterTypeEnum';
import {
    StudyCycleEnum,
    StudyCycleEnumFromJSON,
    StudyCycleEnumFromJSONTyped,
    StudyCycleEnumToJSON,
} from './StudyCycleEnum';
import {
    StudyYearEnum,
    StudyYearEnumFromJSON,
    StudyYearEnumFromJSONTyped,
    StudyYearEnumToJSON,
} from './StudyYearEnum';
import {
    SubjectStatusEnum,
    SubjectStatusEnumFromJSON,
    SubjectStatusEnumFromJSONTyped,
    SubjectStatusEnumToJSON,
} from './SubjectStatusEnum';

/**
 * 
 * @export
 * @interface MyDisciplineDTO
 */
export interface MyDisciplineDTO {
    /**
     * 
     * @type {string}
     * @memberof MyDisciplineDTO
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof MyDisciplineDTO
     */
    code?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MyDisciplineDTO
     */
    nameRO?: string | null;
    /**
     * 
     * @type {StudyYearEnum}
     * @memberof MyDisciplineDTO
     */
    studyYear?: StudyYearEnum;
    /**
     * 
     * @type {SemesterTypeEnum}
     * @memberof MyDisciplineDTO
     */
    semester?: SemesterTypeEnum;
    /**
     * 
     * @type {SubjectStatusEnum}
     * @memberof MyDisciplineDTO
     */
    status?: SubjectStatusEnum;
    /**
     * 
     * @type {boolean}
     * @memberof MyDisciplineDTO
     */
    isPartiallySaved?: boolean;
    /**
     * 
     * @type {string}
     * @memberof MyDisciplineDTO
     */
    studyProgramId?: string;
    /**
     * 
     * @type {string}
     * @memberof MyDisciplineDTO
     */
    programName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MyDisciplineDTO
     */
    facultyName?: string | null;
    /**
     * 
     * @type {StudyCycleEnum}
     * @memberof MyDisciplineDTO
     */
    studyCycle?: StudyCycleEnum;
    /**
     * 
     * @type {string}
     * @memberof MyDisciplineDTO
     */
    departmentId?: string | null;
    /**
     * 
     * @type {number}
     * @memberof MyDisciplineDTO
     */
    courseWeeklyHours?: number;
    /**
     * 
     * @type {Array<AcademicUserNameDTO>}
     * @memberof MyDisciplineDTO
     */
    courseCoordinators?: Array<AcademicUserNameDTO> | null;
    /**
     * 
     * @type {Array<AcademicUserNameDTO>}
     * @memberof MyDisciplineDTO
     */
    labCoordinators?: Array<AcademicUserNameDTO> | null;
}

export function MyDisciplineDTOFromJSON(json: any): MyDisciplineDTO {
    return MyDisciplineDTOFromJSONTyped(json, false);
}

export function MyDisciplineDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): MyDisciplineDTO {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'code': !exists(json, 'code') ? undefined : json['code'],
        'nameRO': !exists(json, 'nameRO') ? undefined : json['nameRO'],
        'studyYear': !exists(json, 'studyYear') ? undefined : StudyYearEnumFromJSON(json['studyYear']),
        'semester': !exists(json, 'semester') ? undefined : SemesterTypeEnumFromJSON(json['semester']),
        'status': !exists(json, 'status') ? undefined : SubjectStatusEnumFromJSON(json['status']),
        'isPartiallySaved': !exists(json, 'isPartiallySaved') ? undefined : json['isPartiallySaved'],
        'studyProgramId': !exists(json, 'studyProgramId') ? undefined : json['studyProgramId'],
        'programName': !exists(json, 'programName') ? undefined : json['programName'],
        'facultyName': !exists(json, 'facultyName') ? undefined : json['facultyName'],
        'studyCycle': !exists(json, 'studyCycle') ? undefined : StudyCycleEnumFromJSON(json['studyCycle']),
        'departmentId': !exists(json, 'departmentId') ? undefined : json['departmentId'],
        'courseWeeklyHours': !exists(json, 'courseWeeklyHours') ? undefined : json['courseWeeklyHours'],
        'courseCoordinators': !exists(json, 'courseCoordinators') ? undefined : (json['courseCoordinators'] === null ? null : (json['courseCoordinators'] as Array<any>).map(AcademicUserNameDTOFromJSON)),
        'labCoordinators': !exists(json, 'labCoordinators') ? undefined : (json['labCoordinators'] === null ? null : (json['labCoordinators'] as Array<any>).map(AcademicUserNameDTOFromJSON)),
    };
}

export function MyDisciplineDTOToJSON(value?: MyDisciplineDTO | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'code': value.code,
        'nameRO': value.nameRO,
        'studyYear': StudyYearEnumToJSON(value.studyYear),
        'semester': SemesterTypeEnumToJSON(value.semester),
        'status': SubjectStatusEnumToJSON(value.status),
        'isPartiallySaved': value.isPartiallySaved,
        'studyProgramId': value.studyProgramId,
        'programName': value.programName,
        'facultyName': value.facultyName,
        'studyCycle': StudyCycleEnumToJSON(value.studyCycle),
        'departmentId': value.departmentId,
        'courseWeeklyHours': value.courseWeeklyHours,
        'courseCoordinators': value.courseCoordinators === undefined ? undefined : (value.courseCoordinators === null ? null : (value.courseCoordinators as Array<any>).map(AcademicUserNameDTOToJSON)),
        'labCoordinators': value.labCoordinators === undefined ? undefined : (value.labCoordinators === null ? null : (value.labCoordinators as Array<any>).map(AcademicUserNameDTOToJSON)),
    };
}

